import useSWR from 'swr';
import { customSWRConfig, customSWRResponse } from '../../model/types';
import { TicketFieldPlaceholderKey } from '../../store/childStore/macroStore';
import useSWRCacheKeys from '../useSWRCacheKeys';

interface IMacro {
    id: number;
    name: string;
    description: string;
    actions: IAction[];
    enabled: boolean;
}
enum MacroActionTypeMap {
    COMMENT = 'COMMENT'
}
enum MacroActionValueTypeMap {
    RICH_TEXT = 'RICH_TEXT'
}
type macroActionType = keyof typeof MacroActionTypeMap;
type macroActionValueType = keyof typeof MacroActionValueTypeMap;
interface IAction {
    actionType: macroActionType;
    value: TicketFieldPlaceholderKey;
}

export default function useMacroList(
    isActiveFields: boolean = null,
    config: customSWRConfig = {}
): customSWRResponse<IMacro[]> {
    let url = '';
    switch (isActiveFields) {
        case null:
            url = '';
            break;
        case true:
            url = '?active';
            break;
        case false:
            url = '?inactive';
            break;
        default:
            url = '';
            break;
    }
    const keys = useSWRCacheKeys(`/macros${url}`);

    return useSWR<IMacro[]>(keys, { ...config });
}

export {
    MacroActionTypeMap,
    MacroActionValueTypeMap,
    type IAction,
    type IMacro,
    type macroActionType,
    type macroActionValueType
};
